import { useServerTranslation } from 'hooks/useServerTranslation';
import { useRouter } from 'next/router';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';

export function useShowNotAuthorizedMessage() {
    const router = useRouter();
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useServerTranslation();

    useEffect(() => {
        if (router.query.notAuthorizedMessage) {
            enqueueSnackbar(t(router.query.notAuthorizedMessage), { variant: 'error' });
            router.query.notAuthorizedMessage = undefined;
        }
    }, [t, router, enqueueSnackbar]);
}
